import { c as _c } from "react/compiler-runtime";
import type { ReactNode, ComponentProps } from "react";
import { Tooltip } from "react-tooltip";
export type WaveTooltipPlacement = ComponentProps<typeof Tooltip>["place"];
interface WaveTooltipProps {
  readonly id: string;
  readonly place: WaveTooltipPlacement;
  readonly children: ReactNode;
}
export const WaveTooltip = t0 => {
  const $ = _c(8);
  const {
    id,
    place,
    children
  } = t0;
  let t1;
  if ($[0] !== place) {
    t1 = place && {
      place
    };
    $[0] = place;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span className="tw-text-xs">{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id || $[5] !== t1 || $[6] !== t2) {
    t3 = <Tooltip id={id} {...t1} positionStrategy="fixed" className="tw-bg-[#37373E] tw-text-white tw-px-2.5 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-md tw-shadow-[0_4px_12px_rgba(0,0,0,0.3)] tw-z-[10000]">{t2}</Tooltip>;
    $[4] = id;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};